import React from 'react';

function Modal() {
const API_URL = "http://157.245.99.57";
  return (
    <div>
      <div className="modal fade" id="myModal" role="dialog">
        <div className="modal-dialog">
          {/* Modal content*/}
          <div className="modal-content" style={{ "border-radius": "20px" }}>
            <button type="button" className="close" data-dismiss="modal">×</button>
            <div className="modal-body member-login-popup">
              <ul className="nav nav-pills">
                <li><i className="fa fa-heart-o" aria-hidden="true" /><a data-toggle="pill" href="#find" id="mysoul">FIND MY SOULMATE</a></li>
                <li className="active"><i className="fa fa-user-circle-o" aria-hidden="true" /><a data-toggle="pill" href="#mlogin" id="mylogin">MEMBER LOGIN</a></li>
              </ul>
              <div className="tab-content">
                <div id="find" className="tab-pane fade">
                  <form method="get" action="`${API_URL}/registers/searchresult`">
                    <div className="form-group">
                      <div className="row">
                        <div className="col-md-6">
                          <label>ID</label>
                          <input type="text" placeholder="Search by ID (Ex : TMM-200)" autoComplete="off" defaultValue className="form-control validate[required]" name="n" />
                          {/*<input type="text" class="form-control" name="id" onkeypress="javascript:convertThis(event);">*/}
                        </div>
                        <div className="col-md-6">
                          <label>Search </label>
                          <select className="form-control validate[required]" name="marital">
                            <option value>---Select---</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="row">
                        <div className="col-md-6">
                          <label>Religion</label>
                          <select className="form-control validate[required]" name="religion">
                            <option value>---Select---</option>
                            <option value="Hindu">Hindu</option>
                            <option value="Muslim">Muslim</option>
                            <option value="Christian">Christian</option>
                            <option value="Jain">Jain </option>
                            <option value="Jewish">Jewish</option>
                            <option value="Parsi">Parsi</option>
                            <option value="Sikh">Sikh</option>
                          </select>
                        </div>
                        <div className="col-md-6">
                          <label>Caste</label>
                          <select className="form-control validate[required]" name="caste">
                            <option value>---Select---</option>
                            <option value={2}>Nadar</option>
                            <option value={39}>Kuravar</option>
                            <option value={53}>Iyengar</option>
                            <option value={5}>Yadavar</option>
                            <option value={38}>Agamudaiyar</option>
                            <option value={8}>Kallar</option>
                            <option value={9}>Maravar</option>
                            <option value={10}>Chettiar</option>
                            <option value={11}>Christian</option>
                            <option value={12}>Mudaliyar</option>
                            <option value={36}>Naidu</option>
                            <option value={35}>Pillaimar </option>
                            <option value={15}>PR</option>
                            <option value={16}>PL</option>
                            <option value={17}>Rediyar</option>
                            <option value={18}>Counter</option>
                            <option value={19}>Muslim</option>
                            <option value={37}>Vishvakarma</option>
                            <option value={22}>Arundhathiyar</option>
                            <option value={23}>Nair</option>
                            <option value={24}>Moopanar</option>
                            <option value={25}>Dharuthuvar</option>
                            <option value={26}>Veerashaivam</option>
                            <option value={27}>Vannar</option>
                            <option value={28}>Vanniyar</option>
                            <option value={29}>Sourashtra</option>
                            <option value={30}>Nayakar</option>
                            <option value={31}>Vellalar</option>
                            <option value={32}>Udaiar</option>
                            <option value={33}>Muthuraja</option>
                            <option value={34}>Muttaraiyar</option>
                            <option value={40}>Phramin</option>
                            <option value={41}>Vellalar</option>
                            <option value={42}>Thevar Maravar</option>
                            <option value={43}>Valluvar</option>
                            <option value={44}>Karunikar</option>
                            <option value={45}>Meenavar</option>
                            <option value={46}>Iyar</option>
                            <option value={47}>Boyar</option>
                            <option value={48}>Thevar</option>
                            <option value={49}>Valluvan</option>
                            <option value={52}>Kulalar</option>
                            <option value={54}>Iyengar</option>
                            <option value={55}>Pathar</option>
                            <option value={56}>Valayar</option>
                            <option value={58}>Marathi</option>
                            <option value={59}>Yogishwarar</option>
                            <option value={61}>Kathriya Raju</option>
                            <option value={64}>Saathada Srivaishnava</option>
                            <option value={65}>S.T.</option>
                            <option value={66}>Eeluvar</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="form_group">
                      <div className="row">
                        {/* <div className="col-md-6">
                          <label>உட்பிரிவு</label>
                          <input type="text" className="form-control" name="subcaste" onkeypress="javascript:convertThis(event);" />
                        </div> */}
                        <div className="col-md-6">
                          <label>Marital status</label>
                          <select className="form-control validate[required]" name="marriage_condition">
                            <option value>---Select---</option>
                            <option value="unmarried"> unmarried</option>
                            <option value="married"> married</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="form-group">
                      <label className="age-top">Age </label>
                      <div className="row">
                        <div className="col-md-6">
                          <select className="form-control validate[required]" name="from">
                            <option value>---From---</option>
                            <option value={18}>18</option>
                            <option value={19}>19</option>
                            <option value={20}>20</option>
                            <option value={21}>21</option>
                            <option value={22}>22</option>
                            <option value={23}>23</option>
                            <option value={24}>24</option>
                            <option value={25}>25</option>
                            <option value={26}>26</option>
                            <option value={27}>27</option>
                            <option value={28}>28</option>
                            <option value={29}>29</option>
                            <option value={30}>30</option>
                            <option value={31}>31</option>
                            <option value={32}>32</option>
                            <option value={33}>33</option>
                            <option value={34}>34</option>
                            <option value={35}>35</option>
                            <option value={36}>36</option>
                            <option value={37}>37</option>
                            <option value={38}>38</option>
                            <option value={39}>39</option>
                            <option value={40}>40</option>
                            <option value={41}>41</option>
                            <option value={42}>42</option>
                            <option value={43}>43</option>
                            <option value={44}>44</option>
                            <option value={45}>45</option>
                            <option value={46}>46</option>
                            <option value={47}>47</option>
                            <option value={48}>48</option>
                            <option value={49}>49</option>
                            <option value={50}>50</option>
                          </select>
                        </div>
                        <div className="col-md-6">
                          <select className="form-control validate[required]" name="to">
                            <option value>---To---</option>
                            <option value={19}>19</option>
                            <option value={20}>20</option>
                            <option value={21}>21</option>
                            <option value={22}>22</option>
                            <option value={23}>23</option>
                            <option value={24}>24</option>
                            <option value={25}>25</option>
                            <option value={26}>26</option>
                            <option value={27}>27</option>
                            <option value={28}>28</option>
                            <option value={29}>29</option>
                            <option value={30}>30</option>
                            <option value={31}>31</option>
                            <option value={32}>32</option>
                            <option value={33}>33</option>
                            <option value={34}>34</option>
                            <option value={35}>35</option>
                            <option value={36}>36</option>
                            <option value={37}>37</option>
                            <option value={38}>38</option>
                            <option value={39}>39</option>
                            <option value={40}>40</option>
                            <option value={41}>41</option>
                            <option value={42}>42</option>
                            <option value={43}>43</option>
                            <option value={44}>44</option>
                            <option value={45}>45</option>
                            <option value={46}>46</option>
                            <option value={47}>47</option>
                            <option value={48}>48</option>
                            <option value={49}>49</option>
                            <option value={50}>50</option>
                            <option value={51}>51</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div>
                      <input type="submit" name="search" className="button small btn btn-primary" defaultValue="search" />
                    </div>
                  </form>
                  <div className="advanced-searc-lnk">
                    <a href="`${API_URL}/registers/register`">New? Register here!</a>
                  </div>
                </div>
                <div id="mlogin" className="tab-pane fade in active">
                  <form method="post" action="`${API_URL}/registers/mlogin`" className="validation_form geting-otp">
                    <div className="form-group">
                      <div className="form-group">
                        <label>Date of birth</label>
                        <input type="text" autoComplete="off" id="dobdatepicker" className="form-control" name="data[Register][date_of_birth]" />
                      </div>
                      {/*<label>பிறந்த தேதி<span class="reguired">*</span></label>                                   */}
                      {/*<div class="row">*/}
                      {/*    <div class="col-md-4">*/}
                      {/*          */}
                      {/*    </div>*/}
                      {/*    <div class="col-md-4">*/}
                      {/*        */}
                      {/*    </div>*/}
                      {/*    <div class="col-md-4">*/}
                      {/*          */}
                      {/*    </div>*/}
                      {/*</div>*/}
                    </div>
                    <div className="form-group">
                      <label>Mobile number <span className="reguired">*</span></label>
                      <input type="text" className="form-control validate[required] phone_number" autoComplete="off" id="phone_number" name="data[Register][phone_number]" style={{ "margin-bottom": "13px" }} />
                      {/*<small>OTP will be send to this mobile number</small>*/}
                      {/*<small style="float:right"><input type="button" id="resend_otp" value="Resend OTP ?"></small>*/}
                    </div>
                    {/*<div class="form-group otp">*/}
                    {/*    <label>OTP</label>*/}
                    {/*    <input type="text" id="otp" class="form-control" name="data[Register][otp]"/>*/}
                    {/*</div>*/}
                    <input type="submit" className="btn send-otp" defaultValue="SUBMIT" />
                  </form>
                  <div className="advanced-searc-lnk">
                    <a href="`${API_URL}/registers/register`">New? Register here!</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>


  )
}
export default Modal;
